import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useUserSelfDetails, userHasRole } from '@steelbuy/data-access';
import { UserRole } from '@steelbuy/ts-shared';
import { EmptyState } from '@steelbuy/ui-primitive';
import { RoutePath } from '../../router/Routes';

export const MyListingEmptyState = ({ navigateTo }: { navigateTo?: string }) => {
    const { t } = useTranslation(['translation', 'uiDomain']);
    const navigate = useNavigate();
    const { data: userModel } = useUserSelfDetails();
    const hasSellerRole = userHasRole(userModel || null, [UserRole.SELLER]);

    return (
        <div className="my-listings-drafts__empty-state-container">
            <EmptyState
                caption={t('uiDomain:commonList.noListCaption')}
                description={hasSellerRole ? t('application.myListings.noResultsDescription') : ''}
                button={
                    hasSellerRole
                        ? {
                              label: t('application.myListings.noListingsCallToAction'),
                              onClick: () => navigate(navigateTo ?? RoutePath.CREATE_LISTING_WIZARD),
                          }
                        : undefined
                }
            />
        </div>
    );
};
